/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { marked } from "marked";
import DOMPurify from "dompurify";
import { acknowledgeConsent } from "../../api/authApi";

const __vue_script__ = {
  name: "ConsentModal",
  // FormMixin was imported here but its authenticityToken computed was never
  // consumed — CSRF is handled by the ky baseApi hooks (acknowledgeConsent).
  props: {
    config: {
      type: Object,
      required: true,
      default: () => ({
        enabled: false,
        required: false,
        version: "1",
        title: "Terms of Use",
        content: "",
      }),
    },
  },
  data() {
    return {
      showModal: false,
      acknowledged: false,
      errorMessage: "",
    };
  },
  computed: {
    sanitizedContent() {
      if (!this.config.content) return "";
      const html = marked(this.config.content);
      return DOMPurify.sanitize(html);
    },
  },
  mounted() {
    // Server tells us whether consent is required via config.required
    if (this.config.enabled && this.config.required) {
      this.showModal = true;
    }
  },
  methods: {
    async onAgree() {
      this.errorMessage = "";
      try {
        await acknowledgeConsent();
        this.acknowledged = true;
        this.showModal = false;
      } catch {
        // POST failed — keep modal visible, consent not recorded, and tell the
        // user (a silent catch made a failed acknowledgment look like a dead
        // button). A successful bodyless 200 no longer lands here — baseApi's
        // parseBody resolves an empty response instead of throwing on it.
        this.errorMessage =
          "We couldn't record your acknowledgment. Please check your connection and try again.";
        this.showModal = true;
      }
    },
    onHidden() {
      // Re-show if not acknowledged (prevents programmatic dismissal)
      if (!this.acknowledged) {
        this.$nextTick(() => {
          this.showModal = true;
        });
      }
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "consent-modal",
        title: _vm.config.title,
        visible: _vm.showModal,
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header-close": "",
        "no-fade": "",
        centered: "",
        size: "lg",
      },
      on: { hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", "data-testid": "consent-agree" },
                  on: { click: _vm.onAgree },
                },
                [_vm._v(" I Agree ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", {
        staticClass: "consent-content",
        domProps: { innerHTML: _vm._s(_vm.sanitizedContent) },
      }),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-3 mb-0",
          attrs: {
            show: !!_vm.errorMessage,
            variant: "danger",
            "data-testid": "consent-error",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7f2aefdc_0", { source: "\n.consent-content[data-v-7f2aefdc] {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n", map: {"version":3,"sources":["app/javascript/components/shared/ConsentModal.vue"],"names":[],"mappings":";AAgGA;EACA,gBAAA;EACA,gBAAA;AACA","file":"ConsentModal.vue","sourcesContent":["<template>\n  <b-modal\n    id=\"consent-modal\"\n    :title=\"config.title\"\n    :visible=\"showModal\"\n    no-close-on-backdrop\n    no-close-on-esc\n    hide-header-close\n    no-fade\n    centered\n    size=\"lg\"\n    @hidden=\"onHidden\"\n  >\n    <!-- eslint-disable-next-line vue/no-v-html -- Content is sanitized via DOMPurify -->\n    <div class=\"consent-content\" v-html=\"sanitizedContent\" />\n    <b-alert :show=\"!!errorMessage\" variant=\"danger\" class=\"mt-3 mb-0\" data-testid=\"consent-error\">\n      {{ errorMessage }}\n    </b-alert>\n    <template #modal-footer>\n      <b-button variant=\"primary\" data-testid=\"consent-agree\" @click=\"onAgree\"> I Agree </b-button>\n    </template>\n  </b-modal>\n</template>\n\n<script>\nimport { marked } from \"marked\";\nimport DOMPurify from \"dompurify\";\nimport { acknowledgeConsent } from \"../../api/authApi\";\n\nexport default {\n  name: \"ConsentModal\",\n  // FormMixin was imported here but its authenticityToken computed was never\n  // consumed — CSRF is handled by the ky baseApi hooks (acknowledgeConsent).\n  props: {\n    config: {\n      type: Object,\n      required: true,\n      default: () => ({\n        enabled: false,\n        required: false,\n        version: \"1\",\n        title: \"Terms of Use\",\n        content: \"\",\n      }),\n    },\n  },\n  data() {\n    return {\n      showModal: false,\n      acknowledged: false,\n      errorMessage: \"\",\n    };\n  },\n  computed: {\n    sanitizedContent() {\n      if (!this.config.content) return \"\";\n      const html = marked(this.config.content);\n      return DOMPurify.sanitize(html);\n    },\n  },\n  mounted() {\n    // Server tells us whether consent is required via config.required\n    if (this.config.enabled && this.config.required) {\n      this.showModal = true;\n    }\n  },\n  methods: {\n    async onAgree() {\n      this.errorMessage = \"\";\n      try {\n        await acknowledgeConsent();\n        this.acknowledged = true;\n        this.showModal = false;\n      } catch {\n        // POST failed — keep modal visible, consent not recorded, and tell the\n        // user (a silent catch made a failed acknowledgment look like a dead\n        // button). A successful bodyless 200 no longer lands here — baseApi's\n        // parseBody resolves an empty response instead of throwing on it.\n        this.errorMessage =\n          \"We couldn't record your acknowledgment. Please check your connection and try again.\";\n        this.showModal = true;\n      }\n    },\n    onHidden() {\n      // Re-show if not acknowledged (prevents programmatic dismissal)\n      if (!this.acknowledged) {\n        this.$nextTick(() => {\n          this.showModal = true;\n        });\n      }\n    },\n  },\n};\n</script>\n\n<style scoped>\n.consent-content {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-7f2aefdc"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/shared/ConsentModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__